import { render, staticRenderFns } from "./ProductFiltersBlock.vue?vue&type=template&id=ea2fc6e6&scoped=true"
import script from "./ProductFiltersBlock.vue?vue&type=script&lang=ts"
export * from "./ProductFiltersBlock.vue?vue&type=script&lang=ts"
import style0 from "./ProductFiltersBlock.vue?vue&type=style&index=0&id=ea2fc6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2fc6e6",
  null
  
)

export default component.exports